import {SxProps, Theme} from '@mui/material';

export const PRINTABLE_CONTAINER_SX: SxProps<Theme> = {
  height: '100%',
  width: '100%',
  '@media print': {
    display: 'block !important',
    width: '100% !important',
    '& .MuiCheckbox-root': {display: 'none'},
    '& > *': {
      display: 'block !important',
      width: '100% !important',
      maxWidth: '100% !important',
      pageBreakInside: 'avoid',
    },
    '& > * > *': {
      display: 'block !important',
      width: '100% !important',
      maxWidth: '100% !important',
      minWidth: '100% !important',
      float: 'none !important',
      position: 'static !important',
    },
    '& > * > * > *': {
      width: '100% !important',
      maxWidth: '100% !important',
    },
  },
} as const;

export const PRINTABLE_MAP_SX: SxProps<Theme> = {
  '@media print': {
    height: '600px !important',
    pageBreakInside: 'avoid',
    pageBreakAfter: 'always',
  },
} as const;

export const PRINT_HIDDEN_SX: SxProps<Theme> = {
  '@media print': {
    display: 'none',
  },
} as const;
